import { runtimeConfig } from './runtimeConfig';
// Environment variables with runtime configuration support
// These values can be overridden at runtime via runtime-config.js
export const WS_URL = runtimeConfig.getWebSocketUrl();
export const ALPHALEND_WS_URL = runtimeConfig.getAlphalendWebSocketUrl();
export const STSUI_WS_URL = runtimeConfig.getStsuiWebSocketUrl();
export const API_BASE_URL = runtimeConfig.getApiBaseUrl();
export const APR_URL = runtimeConfig.getAprUrl();
// Feature flags
export const ENABLE_WEBSOCKET = runtimeConfig.isWebSocketEnabled();
export const ENABLE_DEBUG_LOGS = runtimeConfig.isDebugLogsEnabled();
